var HsCartContentResponse={addItem:function(t,e){},updateItem:function(t,e){},deleteItem:function(t,e){},allItems:function(t,e){}};
//# sourceMappingURL=/s/files/1/0091/6317/8031/t/24/assets/hs-sl-integrations.js.map?v=1646490222
